import { formatMicroDollars, formatPercent } from "@shared/charts/formatNumber";
import { SHERLOCK_CHANGES, SherlockAttributeValue, SherlockChangeType } from "@shared/http/apiTypes/sherlockApiTypes";

const MICRODOLLAR_ATTRIBUTES = ["buying_price", "conversion_cpx", "target_incremental_cpx", "cycle_amount"];
const PERCENT_ATTRIBUTES = ["greediness", "target_margin", "uplift_control_group_share"];

export default function formatChangeTooltipContent(
  changed_attribute: SherlockChangeType,
  prevValue: SherlockAttributeValue,
  newValue: SherlockAttributeValue,
): string {
  let prevValueFormatted: SherlockAttributeValue = prevValue;
  let newValueFormatted: SherlockAttributeValue = newValue;

  if (MICRODOLLAR_ATTRIBUTES.includes(changed_attribute)) {
    prevValueFormatted = `${formatMicroDollars(prevValue as number)}`;
    newValueFormatted = `${formatMicroDollars(newValue as number)}`;
  } else if (PERCENT_ATTRIBUTES.includes(changed_attribute)) {
    prevValueFormatted = `${formatPercent(prevValue as number)}`;
    newValueFormatted = `${formatPercent(newValue as number)}`;
  }

  const attributeName = SHERLOCK_CHANGES[changed_attribute];

  return `${attributeName} was changed from ${prevValueFormatted} to ${newValueFormatted}`;
}
